import React from 'react'
import * as S from './styles'
import { Link } from 'gatsby'
import { Typography } from '@taglivros/tag-components'
import Button from '@site/components/atoms/Button'
import { CookiesTexts } from '@shared/interfaces/CookiesTexts'
import { colors } from '@shared/interfaces/Colors'

const CookiesInformation = ( { onClose } : CookiesInformation.Props ): React.ReactElement => {
  return (
    <S.Container className="fab-information">
      <Typography
        as="h2"
        color="GREY-700-TXT"
        fontFamily="notoSans"
        fontWeight="xl"
        variant="text3"
      >
        { CookiesTexts.PRIVACY_TITLE }
      </Typography>
      <Typography
        as="p"
        color="GREY-700-TXT"
        fontFamily="notoSans"
        fontWeight="s"
        variant="helperText"
      >
        { CookiesTexts.PRIVACY_TEXT }
        { ' ' }
        <Link
          target="_blank"
          to={ CookiesTexts.PRIVACY_LINK }
        >
          { CookiesTexts.PRIVACY_TEXT_LINK }
        </Link>
      </Typography>
      <Button
        backgroundColor={ colors.home.SOLID!.BUTTON_BACKGROUND }
        color={ colors.home.SOLID!.BUTTON_COLOR }
        className="fab-informationmodal__button"
        hover={ colors.home.SOLID!.BUTTON_BACKGROUND }
        onClick={ onClose }
      >
        { CookiesTexts.PRIVACY_BUTTON }
      </Button>
    </S.Container>
  )
}

namespace CookiesInformation {
  export interface Props {
    onClose( event: React.MouseEvent<HTMLAnchorElement> ): void
  }
}

export default CookiesInformation
